import script from "./PopupFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupFiles.vue?vue&type=script&setup=true&lang=js"

import "./PopupFiles.vue?vue&type=style&index=0&id=ad48bf7a&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad48bf7a"]])

export default __exports__